<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['antenatal_patients']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="m-0 d-flex justify-content-md-center">
                <div class="form-group">
                <label>Date From</label>
                <input v-model="datefrom" type="date" class="form-control" />
                </div>
                <div class="form-group ms-2">
                <label>Date To</label>
                <input v-model="dateto" type="date" class="form-control" />
                </div>
                <span><br><b-button @click="FilterData" class="mt-2 mx-2" variant="primary"><i class="mdi mdi-filter"></i> Filter</b-button></span>
              </div>
              <div class="clearfix"></div>
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                      <label class="d-inline-flex align-items-center">
                        Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <b-table
                    :items="Items"
                    :fields="Fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="Filtered"
                    :busy="IsBusy"
                  >
                  <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(patient_id)="data">
                  {{ data.item.patient.patient_id }}
                </template>
                <template #cell(name)="data">
                  <b>{{ data.item.patient.name }}</b><br>
                  <small>0{{ data.item.patient.telephone }}</small>
                  <span v-if="data.item.traige.turnaroundtime==2"><i class="bx bx-flashing"><span class="badge bg-danger rounded-pill">emergency</span></i></span>
                </template>
                <template #cell(gender)="data">
                 <b>{{ data.item.patientage }} <small>yrs</small></b><br> {{ data.item.patient.gender }}
                </template>
                <template #cell(telephone)="data">
                  0{{ data.item.patient.telephone }}
                </template>
                <template #cell(address)="data">
                  {{ data.item.patient.address }}
                </template>
                <template #cell(service)="data">
                  {{ data.item.service_name.name }}
                </template>
                <template #cell(paystatus)="data">
                  {{ data.item.rtreatment }}
                  <span v-if="data.item.paystatus>0"> <b-button class="btn btn-info btn-sm" type="button">paid</b-button> </span>
                  <span v-else> <b-button class="btn btn-danger btn-sm" type="button">Not Paid</b-button></span>
                  <br>
                  <b v-if="data.item.treatment==0" class="text-danger">Not worked On </b>
                  <b v-else class="text-primary">worked On</b>
                </template>
                <template #cell(actions)="data">
                    <router-link :to="{ path: '/antenataltreatment',  query: { id:data.item.id, }}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-square-edit-outline"></i> Treatment</router-link>
                </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Antenatal Patients</span></center>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  </template>
  
  <script>
  // import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { antenatalPatientMethods, antenatalPatientComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Antenatal Patients",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Antenatal Patients",
        items: [ {text: "Dashboard",to: "/",}, {text: "Antenatal Patients",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'gender', label: 'Gender', visible: true },
          { key: 'telephone', label: 'Telephone', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'service', label: 'Service', visible: true },
          { key: 'addedon', label: 'Visit Date', visible: true },
          { key: 'paystatus', label: 'Status', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      datefrom: new Date().toLocaleDateString('fr-CA'),
      dateto: new Date().toLocaleDateString('fr-CA'),
      };
    },
    computed: {
      ...antenatalPatientComputed,
      List() { return this.antenatalpatients.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.antenatalpatients.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.antenatalpatients.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchAntenatalPatients();
      this.TotalRows = this.antenatalpatients.length;
      this.isBusy=false;
    },
    methods: {
      ...antenatalPatientMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      FilterData() {  this.filterAntenatalPatients({datefrom:this.datefrom,dateto:this.dateto});  },
    }
  };
  </script>